import React from 'react';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';
import styles from './DENTModalOverviewGeneralEndodonticButtons.module.scss';
import { ToothEndodontic } from '../../../../graphql/graphql';
import useTooth from '../../Hooks/Tooth/useTooth';
import { useDENTContext } from '../../Services/DENTContext';
import { EndodonticButtonOption } from '../../Helpers/endodontic/endodonticButtonOptions';
import DENTModalOverviewButtonsSelection from '../DENTModalOverviewButtonsSelection/DENTModalOverviewButtonsSelection';

interface Props<T extends EndodonticButtonOption['value']> {
	type: T;
	values: ToothEndodontic[T];
	onClose: () => void;
	children: React.ReactNode;
}

const DENTModalOverviewGeneralEndodonticButtons = <
	T extends EndodonticButtonOption['value'],
>({
	type,
	values,
	children,
	onClose,
}: Props<T>) => {
	const { endodontic } = useTooth();
	const { handleUpdateTooth } = useDENTContext();

	const handleUpdate = () => {
		handleUpdateTooth({
			endodontic: {
				...endodontic.getEndodontic,
				[type]: values,
			},
		});
	};

	const handleDelete = () => {
		handleUpdateTooth({
			endodontic: {
				...endodontic.getEndodontic,
				[type]: undefined,
			},
		});
	};

	return (
		<div className={styles.wrapper}>
			<DENTModalOverviewButtonsSelection
				title={`patientTreatment.meddiDENT.dentalCross.endodontic.${type}`}
				onClose={onClose}>
				{children}
				<div className={styles.buttonsWrapper}>
					<Button title={'base.shared.form.send'} onClick={handleUpdate} />
					<Button
						title={'base.remove'}
						theme={Theme.RED}
						onClick={handleDelete}
					/>
				</div>
			</DENTModalOverviewButtonsSelection>
		</div>
	);
};

export default DENTModalOverviewGeneralEndodonticButtons;
